import { execute, GraphQLRequest } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';

const uapiLink = new HttpLink({
  uri: 'https://uapi.climate.com/app/graphql',
  headers: {
    'x-http-caller-id': process.env.npm_package_name,
    'x-http-caller-version': process.env.npm_package_version,
    'content-type': 'application/json',
  },
  credentials: 'include',
});

export const uapiConnection = (request: GraphQLRequest) =>
  new Promise((resolve, reject) => {
    execute(uapiLink, request).subscribe({
      next: (data) => resolve(data),
      error: (error) => reject(error),
    });
  });
